<template>
  <el-form-item
    v-if="visible"
    :label="$t('lang.旋转速度') + '：'">
    <el-select
      v-if="isAir"
      disabled
      :placeholder="$t('lang.请选择')"
      value="" />
    <el-select
      v-else
      :disabled="disabled"
      @change="handleChange"
      default-first-option
      :placeholder="$t('lang.请选择')"
      filterable
      v-model="localValue">
      <template v-if="devMode">
        <el-option
          v-for="r in rotateSpeedOptions"
          :key="'rotateSpeed_' + r"
          :label="r"
          :value="r" />
      </template>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'RotateSpeed',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    },
    isAir: {
      type: Boolean,
      default: false
    },
    getMotorGearCount: {
      type: Function,
      required: true
    },
    // 当前旋转方向值，用于计算选项
    rotateDirection: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('ROTATE_SPEED');
    },
    disabled() {
      if (this.isAir) return true;
      if (!this.permissions.includes('ROTATE_SPEED')) return true;
      return !this.devMode?.motorGearChange;
    },
    motorGearCount() {
      if (!this.devMode) return 0;
      // 通过访问 this.rotateDirection 来建立响应式依赖
      // 这样当 rotateDirection 变化时，这个 computed 会重新计算
      const rotateDir = this.rotateDirection;
      return this.getMotorGearCount(this.devMode);
    },
    rotateSpeedOptions() {
      if (!this.devMode) return [];
      const options = [];
      // 确保依赖 rotateDirection，当它变化时重新计算
      const rotateDir = this.rotateDirection;
      const count = this.motorGearCount;
      for (let r = 1; r <= count; r++) {
        if ((r - 1) >= this.devMode.minMotorGear) {
          options.push(r - 1);
        }
      }
      return options;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

